import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  initAnalytics,
  setupClickTracking,
  trackPageView,
} from "helpers/analytics/analytics";

const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    return setupClickTracking();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;

    const timer = window.setTimeout(() => {
      trackPageView(path, document.title);
    }, 100);

    return () => window.clearTimeout(timer);
  }, [location]);

  return null;
};

export default RouteAnalytics;
